// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setReturnPhoneNumber from "@store/Framework/Store/Pages/RequestRma/Handlers/SetRmaPhoneNumber";
import { RmaFormContext } from "@store/Library/Widgets/RequestRma/RequestRmaForm";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    phoneNumber: state.store.pages.requestRma.phoneNumber,
});

const mapDispatchToProps = {
    setReturnPhoneNumber,
};

export interface RequestRmaPhoneNumberStyles {
    wrapper?: InjectableCss;
}

export const phoneNumberStyles: RequestRmaPhoneNumberStyles = {
    wrapper: {
        css: css`
            padding-bottom: 20px;
        `,
    },
};

const styles = phoneNumberStyles;
const phoneRegex = /^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RequestRmaStorePhoneNumber: FC<Props> = ({ phoneNumber, setReturnPhoneNumber }) => {
    const [phoneNumberErrorMessage, setPhoneNumberErrorMessage] = React.useState("");
    const rmaFormContext = useContext(RmaFormContext);
    const { value: order } = useContext(OrderStateContext);

    const phoneNumberChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setReturnPhoneNumber({ phoneNumber: event.target.value });
    };

    const validatePhoneNumber = () => {
        const errorMessage = !phoneNumber
            ? siteMessage("ContactUsForm_PhoneNumberIsRequiredErrorMessage")
            : !phoneNumber || phoneRegex.test(phoneNumber)
            ? ""
            : siteMessage("ContactUsForm_PhoneNumberIsInvalidErrorMessage");
        setPhoneNumberErrorMessage(errorMessage as string);
        return !errorMessage;
    };

    React.useEffect(() => {
        rmaFormContext.validators.phoneNumber = validatePhoneNumber;
    }, [phoneNumber]);

    if (!order) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <TextField
                label={translate("Phone Number")}
                required
                value={phoneNumber}
                onChange={phoneNumberChangeHandler}
                onBlur={validatePhoneNumber}
                error={phoneNumberErrorMessage}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestRmaStorePhoneNumber),
    definition: {
        allowedContexts: ["RequestRmaPage"],
        group: "Return Request (RMA)",
        displayName: "Store Phone Number",
        fieldDefinitions: [],
    },
};

export default widgetModule;
